module.exports = __webpack_public_path__ + "img/full-logo.64352b37.png";